import { render, staticRenderFns } from "./feepay.vue?vue&type=template&id=8675de2a&scoped=true"
import script from "./feepay.vue?vue&type=script&lang=js"
export * from "./feepay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8675de2a",
  null
  
)

export default component.exports